import Image from 'gatsby-image';
import React from 'react';
import AliceCarousel from 'react-alice-carousel';
import 'react-alice-carousel/lib/alice-carousel.css';
import styled from '@emotion/styled'
import { css } from '@emotion/core'
import { cx } from 'emotion';
import { containers, Grid, responsiveFontSize } from 'style';
import { Markdown } from '..';

const SideBySideTextCarouselComponent = ({ text, images, jobs }) => (
    <Grid.Container id="SideBySideTextCarouselComponent">
        <Grid.Row css={row_css}>
            <Left css={column}>
                <Markdown source={text} jobs={jobs} />
            </Left>

            <Right css={column}>
                <CarouselComponent images={images} />
            </Right>
        </Grid.Row>
    </Grid.Container>
);


const row_css = css`

  @media (max-width: ${containers.innerPX - 1}px) {
    display: block;
  }
`;
const column = css`
  white-space: pre-wrap;
  flex: 1 1 100%;
  width: 100%;
  box-sizing: border-box;
  @media (min-width: ${containers.innerPX}px) {
      flex: 1 0 500px;
      max-width: 100%;
  }
`;
const Left = styled.div`
    padding-bottom: 2vw;
    padding: ${containers.padding}px;
    margin: 0;
    justify-content: center;
    > :first-child {
        margin-top: 0;
    }
    @media (min-width: ${containers.innerPX}px) {
      display: flex;
      flex-direction: column;
      padding-left: ${containers.padding}px;
      padding-right: 50px;
    }
    @media (min-width: ${containers.outerPX}px) {

        padding-left: 175px;
    }
    @media (min-width: ${containers.innerPX + containers.padding * 2}px) {
        padding-left: calc((100% - 1330px) / 2);
    }
`;
const Right = styled.div`
    overflow: hidden;
`;

const Col = styled(Grid.Col)`
    display: flex;
    flex-wrap: wrap;
    @media (min-width: 1024px) {
    }

    flex-direction: ${props => (props.textRight ? 'row-reverse' : 'row')};

    ${Left} > div {
        @media (min-width: ${1000 + containers.padding * 2}px) {
            padding: ${props => (props.textRight ? '0 0 0 7vw' : '0 7vw 0 0')};
        }
    }
`;

const padding = 35;

class CarouselComponent extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            currentIndex: 0,
            currentSlideNum: 0,
        };

        // this.next = this.next.bind(this);
        // this.prev = this.prev.bind(this);
        this.onSlideChanged = this.onSlideChanged.bind(this);
        //this.onSlideChange = this.onSlideChange.bind(this);
    }
    // next() {
    //     this.setState({
    //       currentIndex: this.state.currentIndex + 1,
    //     });
    // }

    // prev() {
    //     this.setState({
    //       currentIndex: this.state.currentIndex - 1,
    //     });
    // }
    // onSlideChange(e) {
    //     console.log('Item`s position during a change: ', e.item);
    //     console.log('Slide`s position during a change: ', e.slide);
    // }

    onSlideChanged(e) {
        this.setState({ currentIndex: e.slide });
    }
    galleryItems() {
        return (
            this.props.images &&
            this.props.images.map((image, i) => (
                <Slide key={`key-${i}`}>
                    <SlideContainer>
                        <Image {...image} />
                    </SlideContainer>
                </Slide>
            ))
        );
    }
    render() {
        const items = this.galleryItems();
        const settings = {
            items: items,
            autoPlay: false,
            buttonsDisabled: true,
            dotsDisabled: true,
            startIndex: this.state.currentIndex,
            mouseDragEnabled: true,
            infinite: true,
            autoPlayActionDisabled: true,
        };
        return (
            <CarouselWrapper>
                <div
                    onClick={() => this.carousel._slidePrev()}
                    css={[buttons_css, prev_button_css]}
                    data-cursor="hero"
                    data-cursor-persistance="400"
                    data-cursor-props={JSON.stringify({
                        rotation: '90deg',
                    })}
                />
                <div
                    onClick={() => this.carousel._slideNext()}
                    css={[buttons_css, next_button_css]}
                    data-cursor="hero"
                    data-cursor-persistance="400"
                    data-cursor-props={JSON.stringify({
                        rotation: '-90deg',
                    })}
                />
                <AliceCarousel
                    {...settings}
                    ref={el => {
                        this.carousel = el;
                    }}
                    // slideToIndex={this.state.currentIndex}
                    // onSlideChange={this.onSlideChange}
                    onSlideChanged={this.onSlideChanged}
                    css={carousel_css}
                />

                <CarouselCounter>
                    {this.state.currentIndex + 1}/{settings.items &&
                        settings.items.length}
                </CarouselCounter>
            </CarouselWrapper>
        );
    }
}

const CarouselWrapper = styled.div`
    width: 100%;
    position: relative;
    max-width: 600px;
    .alice-carousel {
        padding: 0;
        max-width: 600px;
    }
    .alice-carousel__wrapper {
        overflow: visible;
        border: 0;
    }
    .alice-carousel__stage-item {
        max-height: 100vh;
    }
`;

const CarouselCounter = styled.div`
    max-width: 600px;
    padding: 10px;
    padding-right: ${padding}px;
    text-align: right;
`;

const buttons_css = css`
    position: absolute;
    top: 0;
    z-index: 1;
    width: 20%;
    height: 100%;
`;
const next_button_css = css`
    right: ${padding}px;
`;
const prev_button_css = css`
    left: ${padding}px;
`;
const carousel_css = css`
    overflow: visible;
    .carousel-slider {
        overflow: visible;
    }
    .slider-wrapper {
        overflow: visible;
    }
    .slide {
        background-color: transparent;
    }
`;

const SlideContainer = styled.div`
    margin: auto;
    height: 100%;
`;

const Slide = styled.div`
    padding-right: ${padding}px;
    pointer-events: none;
`;

const Text = styled.div`
    opacity: 0;
    &:not(:empty) {
        padding-top: 40px;
    }
    text-align: center;
    ${responsiveFontSize(14, 18)};
    transition: opacity 0.5s;
    color: #000;
    .__active & {
        opacity: 1;
    }
`;

export default SideBySideTextCarouselComponent;
